import { TS_AddonDinner } from '../TravelSeller/Models/TS_AddonDinner';
import { BookingItemInterface } from './BookingItemInterface';

export class AddonDinner extends TS_AddonDinner implements BookingItemInterface {
}